import { render } from "./MailerSettings.vue?vue&type=template&id=4fb14a00"
import script from "./MailerSettings.vue?vue&type=script&lang=js"
export * from "./MailerSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__